import Api from 'libs/api';
import axios from 'axios';
import AuthService from 'services/Auth';

class OrdersApi extends Api {
  constructor() {
    super('orders');
  }

  getVirtualTel = (orderId) => {
    return this.get(`${orderId}/virtual_phone`);
  }

  getExcel = (params = {}) => {
    return axios({
      url: `${this.url}.xlsx`,
      method: 'get',
      data: params.data,
      params: params.params,
      responseType: 'blob', // important
      headers: {
        'Content-Type': 'application/json',
        ...(params?.headers || {}),
        'auth-token': AuthService.getToken(),
      },
    });
  }
}

export default OrdersApi;
